import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';

function getCondicionLabel(rawCondicion) {
  const value = (rawCondicion || '').trim();
  if (value === 'Aprobada' || value === 'A') return 'Aprobada';
  if (value === 'Regular' || value === 'R') return 'Regular';
  return value || '—';
}

function getCondicionBadgeClass(rawCondicion) {
  const value = (rawCondicion || '').trim();
  if (value === 'Aprobada' || value === 'A') return 'md-page__badge md-page__badge--info';
  if (value === 'Regular' || value === 'R') return 'md-page__badge md-page__badge--neutral';
  return 'md-page__badge';
}

export class MDCorrelatividadCursar extends Component {
  static displayName = MDCorrelatividadCursar.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
    };
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    if (constantClass.canAccess('WWCorrelatividadesCursada')) {
      this.populateData();
    }
  }

  handleRemoveItem = (item) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: item.correlatividadCursarCod,
        materia: `${item.materiaCarreraMostrar} - ${item.materiaCarreraNombre}`,
        correlativa: `${item.materiaCarreraMostrar2} - ${item.materiaCarreraNecesaria}`,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  renderTable(items) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed md-correlatividad__table" aria-labelledby="md-ccursar-title">
          <colgroup>
            <col className="md-correlatividad__col-materia" />
            <col className="md-correlatividad__col-necesaria" />
            <col className="md-correlatividad__col-condicion" />
            <col className="md-correlatividad__col-carrera" />
            <col className="md-correlatividad__col-actions" />
          </colgroup>
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text" className="md-correlatividad__cell md-correlatividad__cell--materia">Materia</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-correlatividad__cell md-correlatividad__cell--necesaria">Materia Necesaria</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-correlatividad__cell md-correlatividad__cell--condicion md-page__table__badge-cell">Condición</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-correlatividad__cell md-correlatividad__cell--carrera">Carrera</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.correlatividadCursarCod}>
                <td className="md-correlatividad__cell md-correlatividad__cell--materia md-page__table__cell--text">
                  {item.materiaCarreraMostrar + ' - ' + item.materiaCarreraNombre}
                </td>
                <td className="md-correlatividad__cell md-correlatividad__cell--necesaria md-page__table__cell--text">
                  {item.materiaCarreraMostrar2 + ' - ' + item.materiaCarreraNecesaria}
                </td>
                <td className="md-correlatividad__cell md-correlatividad__cell--condicion md-page__table__cell--text md-page__table__badge-cell">
                  <span className={getCondicionBadgeClass(item.correlatividadCursarCondicion)}>
                    {getCondicionLabel(item.correlatividadCursarCondicion)}
                  </span>
                </td>
                <td className="md-correlatividad__cell md-correlatividad__cell--carrera md-page__table__cell--text">{item.carreraNombre}</td>
                <MdTableActionsCell>
                  <MdRowActions
                    items={buildStandardRowActions({
                      editTo: '/update-ccursar/' + item.correlatividadCursarCod + '/0',
                      onDelete: () => this.handleRemoveItem(item),
                      deleteDisabled: this.state.loading || this.state.deletingId === item.correlatividadCursarCod,
                      deleteLabel: this.state.deletingId === item.correlatividadCursarCod ? 'Eliminando...' : 'Borrar',
                      detailTo: '/update-ccursar/' + item.correlatividadCursarCod + '/1',
                    })}
                  />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.deletingId;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-ccursar">
        <h1 id="md-ccursar-title" className="md-page__title">Manejar Datos de Correlatividades para Cursar</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <div className="md-page__toolbar">
          <Link className="md-page__action-link" to="/add-ccursar">
            <PlusIcon />
            Nueva Correlatividad
          </Link>
        </div>

        <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
          <div className="md-page__search-wrap">
            <span className="md-page__search-icon">
              <SearchIcon />
            </span>
            <input
              ref={this.searchInputRef}
              className="md-page__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={isBusy}
              placeholder="Ingrese materia o materia necesaria"
              value={this.state.searchInput}
              onChange={this.handleSearchInputChange}
            />
          </div>
          <button type="submit" className="md-page__search-btn" disabled={isBusy}>
            Buscar
          </button>
        </form>

        {contents}

        {!listLoading && this.state.pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(this.state.offset / this.state.perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar correlatividad para cursar"
          message="Esta acción eliminará la correlatividad del sistema y no se puede deshacer."
          detail={
            pendingDelete
              ? `${pendingDelete.materia} → ${pendingDelete.correlativa}`
              : ''
          }
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/ccursar/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/ccursar/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data) || data.returnModel === false) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo eliminar la correlatividad. Verifique si tiene registros asociados e intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({
        successMessage: 'La correlatividad se eliminó correctamente.',
        pendingDelete: null,
      });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }
}
